var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.imgIsLoaded ? 'show' : '',attrs:{"data-url":_vm.dataUrl,"alt":_vm.alt,"title":_vm.postTitle,"src":_vm.dataUrl,"loading":"lazy"},on:{"error":_vm.setDefaultImg,"load":_vm.imgLoadedMethod}})}
var staticRenderFns = []

export { render, staticRenderFns }